import React from "react";

const EmployeeLogin = () => {
  return <div>EmployeeLogin</div>;
};

export default EmployeeLogin;
